import { useState } from "react";
import { EXPERIENCE_TABS, TRACK_STATS, TRACK_SECTORS, TRACK_RECORD, SIGNATURE_RESULTS } from "../../data/content";

export const Experience = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeItem, setActiveItem] = useState(0);
  const [sector, setSector] = useState("All");

  const tab = EXPERIENCE_TABS[activeTab];
  const records = sector === "All" ? TRACK_RECORD : TRACK_RECORD.filter((r) => r.sector === sector);

  return (
    <section className="section" id="experience" aria-labelledby="exp-heading">
      <div className="container">
        <div className="section-header">
          <div className="section-label">Career Dashboard</div>
          <h2 className="section-heading" id="exp-heading">Professional <em>Experience</em></h2>
          <p className="section-sub">
            Two decades leading evaluations, building MEL architectures, and directing evidence strategy
            across humanitarian, development, and governance contexts worldwide.
          </p>
        </div>

        <div className="sig-results" data-testid="signature-results" aria-label="Signature results">
          {SIGNATURE_RESULTS.map((r) => (
            <div className="sig-result" key={r.label}>
              <div className="sig-result-value">{r.value}</div>
              <div className="sig-result-label">{r.label}</div>
            </div>
          ))}
        </div>

        <div className="exp-tabs" role="tablist" aria-label="Experience categories">
          {EXPERIENCE_TABS.map((t, i) => (
            <button key={t.id} className={`exp-tab ${activeTab === i ? "active" : ""}`}
                    role="tab" aria-selected={activeTab === i}
                    data-testid={`exp-tab-${t.id}`}
                    onClick={() => { setActiveTab(i); setActiveItem(0); }}>
              {t.label}
            </button>
          ))}
        </div>

        <div className="exp-panel active" role="tabpanel">
          <div className="timeline">
            {tab.items.map((item, i) => (
              <div key={item.org + i}
                   className={`timeline-item ${activeItem === i ? "active-item" : ""}`}
                   data-testid={`timeline-item-${tab.id}-${i}`}
                   onClick={() => setActiveItem(i)}>
                <div className="timeline-meta">
                  <span className="timeline-org">{item.org}</span>
                  <span className="timeline-period">{item.period}</span>
                </div>
                <div className="timeline-body-wrap">
                  <div className="timeline-role">{item.role}</div>
                  <div className="timeline-desc">{item.desc}</div>
                  <div className="timeline-tags">
                    {item.tags.map(([text, primary]) => (
                      <span key={text} className={`timeline-tag ${primary ? "timeline-tag--primary" : ""}`}>{text}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ─── FULL TRACK RECORD ─── */}
        <div className="track-section">
          <h3 className="track-head">Full <em>Track Record</em></h3>
          <p className="track-intro">
            A searchable archive of {TRACK_RECORD.length}+ documented evaluation, research, MEL, and
            advisory assignments delivered for INGOs, UN agencies, foundations, and bilateral donors.
          </p>

          <div className="track-stats">
            {TRACK_STATS.map((s) => (
              <div className="track-stat" key={s.label}>
                <div className="track-stat-num">{s.value}</div>
                <div className="track-stat-label">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="track-filters" role="group" aria-label="Filter track record by sector">
            {TRACK_SECTORS.map((s) => (
              <button key={s} className={`filter-btn ${sector === s ? "active" : ""}`}
                      data-testid={`track-filter-${s.replace(/[^a-zA-Z]/g, "").toLowerCase()}`}
                      onClick={() => setSector(s)}>
                {s}
              </button>
            ))}
          </div>

          <div className="track-count">
            Showing {records.length} of {TRACK_RECORD.length} engagements
          </div>

          <div className="track-grid">
            {records.map((r, i) => (
              <div className="track-card" key={r.title + i} data-testid={`track-card-${i}`}>
                <div className="track-card-sector">{r.sector}</div>
                <div className="track-card-title">{r.title}</div>
                <div className="track-card-client">{r.client}</div>
                <div className="track-card-meta">
                  <span>{r.role}</span><span>·</span><span>{r.location}</span><span>·</span><span>{r.year}</span>
                </div>
                <div className="track-card-tags">
                  <span className="track-tag track-tag--donor">{r.donor}</span>
                  {r.metric && <span className="track-tag track-tag--metric">{r.metric}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
